<template>
    <div>
        <v-app-bar
                app
                color="primary"
                dark
        >
            <v-app-bar-nav-icon @click.stop="navButtonClicked"/>
            <h3 v-if="$vuetify.breakpoint.name === 'xs'" style="font-size: 1.1rem !important" class="display-3 px-1">{{title}}</h3>
            <h3 v-if="$vuetify.breakpoint.name !== 'xs'" style="font-size: 2rem !important" class="display-3 px-1">{{title}}</h3>
            <v-spacer/>
            <SearchMembers small clearableAddedIcon @memberSelected="memberSelected"/>
            <v-spacer/>
        </v-app-bar>

      <ErrorDialog ref="errorDialog"/>
    </div>
</template>

<script>
import SearchMembers from "./SearchMembers";
import ErrorDialog from "@/components/ErrorDialog";
import { proxyAsMember } from "@/helpers/memberProxyHelper";

export default {
        name: "AppBar",
        props: {
            titleProp: String,
            default() {
                return {};
            }
        },
        components: {ErrorDialog, SearchMembers},
        data: () => ({
            reportItems: ['Pending Transactions', 'Tithing', 'Credit/Debit/ACH', 'Wire/Check', 'Cards', 'Checks'],
        }),

        computed: {

            title () {
                if (this.titleProp) {
                    return this.titleProp;
                } else {
                    return '';
                }
            },
        },

        methods: {
            navButtonClicked: function () {
                this.$emit('navButtonClicked')
            },
            memberSelected: async function (member) {
                try {
                    await proxyAsMember(this.$axios, member.email, 'testClient');
                } catch (e) {
                  console.log(e);
                  this.$refs.errorDialog.showError({
                    errorMessage: "Error proxying into the account",
                    forDevelopers: e.response.data.message
                })
              }
            }
        }
    }
</script>

<style scoped>

</style>